module.exports = __webpack_public_path__ + "img/a24.8ef1f9a5.png";